import type { ICalendarPlusSettings } from '.';

export const DEFAULT_FORMATS = {
	date: 'MM/dd/yyyy',
	month: 'MMMM dd',
	time: 'hh:mm a',
};

export const DEFAULT_CALENDAR_VIEW = 'month';

export const BREAK_POINTS = {
	mobile: 600,
};

export const LAYOUT_ALGORITHM = {
	OVERLAP: 'overlap',
	NO_OVERLAP: 'no-overlap',
	MIXED: 'mixed',
};

const defaultThemeColors = {
	calendarBackgroundColor: '#ffffff',
	calendarTextColor: '#2D3539',
	calendarToolbarBackgroundColor: '#ffffff',
	calendarTodayCellBackgroundColor: '#eaf6ff',
	calendarSelectedCellBackgroundColor: '#f7f7f7',
	calendarPlaceholderCellBackgroundColor: '#ffffff',
	calendarBordersColor: '#dddddd',
	calendarButtonsColor: '#2B7CD4',
	eventColor: '#32C0CD',
	eventTextColor: '#FFFFFF',
	eventTooltipColor: '#6c6685',
	eventTooltipTextColor: '#FFFFFF',
	eventModalBannerColor: '#4cc2e6',
	eventModalBackgroundColor: '#ffffff',
	eventModalCardsColor: '#F1F3F4',
	filtersBackgroundColor: '#ffffff',
	filtersTextColor: '#2D3539',
};

const darkModeColors = {
	calendarBackgroundColor: '#1F1F1F',
	calendarTextColor: '#B0B0B0',
	calendarToolbarBackgroundColor: '#2A2A2A',
	calendarTodayCellBackgroundColor: '#3A3A3A',
	calendarSelectedCellBackgroundColor: '#4A4A4A',
	calendarPlaceholderCellBackgroundColor: '#333333',
	calendarBordersColor: '#444444',
	calendarButtonsColor: '#7D8B94',
	eventColor: '#79B4A9',
	eventTextColor: '#FFFFFF',
	eventTooltipColor: '#383838',
	eventTooltipTextColor: '#B0B0B0',
	eventModalBannerColor: '#80C1B1',
	eventModalBackgroundColor: '#2A2A2A',
	eventModalCardsColor: '#353535',
	filtersBackgroundColor: '#2A2A2A',
	filtersTextColor: '#B0B0B0',
};

export const defaultCalendarSettings = {
	apiUrl: '',
	monthView: true,
	weekView: true,
	dayView: true,
	agendaView: true,
	enableCalendarFilters: true,
	defaultView: '',
	backButtonLabel: 'Back',
	nextButtonLabel: 'Next',
	todayButtonLabel: 'Today',
	monthButtonLabel: 'Month',
	weekButtonLabel: 'Week',
	dayButtonLabel: 'Day',
	agendaButtonLabel: 'Agenda',
	timeLabel: 'Time',
	locationLabel: 'Location',
	eventDetailLabel: 'Event Details',
	showMoreLabel: 'Show More',
	registerEventButtonLabel: 'Register',
	dateFormat: '',
	timeFormat: '',
	monthFormat: '',
	customDateFormat: '',
	customTimeFormat: '',
	customMonthFormat: '',
	formats: {
		monthFormat: DEFAULT_FORMATS.month,
		dateFormat: DEFAULT_FORMATS.date,
		timeFormat: DEFAULT_FORMATS.time,
	},
	showTooltip: true,
	eventCategoryColors: {},
	styles: {
		light: defaultThemeColors,
		dark: darkModeColors,
	},
	layoutAlgorithm: 'no-overlap',
	enableFeaturedImage: false,
	tagColorScheme: 'blue',
	tagVariant: 'solid',
	categoryColorScheme: 'gray',
	categoryVariant: 'solid',
	radius: {
		toolbar: 'none',
		calendarView: 'none',
	},
	showFiltersOnTop: false,
} as ICalendarPlusSettings;

export const WEEK_DAYS = [
	{ value: 0, label: 'SUN' },
	{ value: 1, label: 'MON' },
	{ value: 2, label: 'TUE' },
	{ value: 3, label: 'WED' },
	{ value: 4, label: 'THU' },
	{ value: 5, label: 'FRI' },
	{ value: 6, label: 'SAT' },
];

export const DEFAULT_WEEK_DAY = 0;

export const RADIUS = {
	xs: '1px',
	sm: '2px',
	md: '4px',
	lg: '8px',
	xl: '12px',
	'2xl': '16px',
	'3xl': '32px',
};
